import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/bo/tools/guarantees-tables')({
  component: () => <Navigate replace search to="/bo/guarantees-tables" />,
})
